import * as React from "react";
import { Button } from "react-ui";
import { MultiStepFooter } from "@skbkontur/react-ui-tour";

import { Body, Content, Footer, FoxImage, Header, Root } from "./TourModalStepContent.styles";

type KewebStyle = "keweb" | "keweb1";

interface TourModalStepContentProps {
    buttonBackText?: string;
    buttonText?: string;
    content: React.ReactNode;
    header: React.ReactNode;
    isFirst: boolean;
    onNext: () => void;
    onPrev: () => void;
    style?: KewebStyle | string;
    points: number;
    activePoint: number;
    stepsCount: number;
    activeStepIndex: number;
    width?: number;
}

export function TourModalStepContent(props: TourModalStepContentProps): JSX.Element {
    const { isFirst, onNext, style, header, content, buttonText = "Далее", width } = props;

    return (
        <Root kewebStyle={style} width={width}>
            {(style === "keweb" || style === "keweb1") && <FoxImage />}
            <Content>
                <Header>{header}</Header>
                <Body>{content}</Body>
                {isFirst ? (
                    <Footer>
                        <Button size={style === "keweb1" ? "large" : "medium"} use="primary" onClick={onNext}>
                            {buttonText}
                        </Button>
                    </Footer>
                ) : (
                    MultiStepFooter(props)
                )}
            </Content>
        </Root>
    );
}
